export const LOAD_RELATED_PRODUCTS_DATA = 'dashboard/LOAD_RELATED_PRODUCTS_DATA';
export const SET_RELATED_PRODUCTS_STATUS = 'dashboard/SET_RELATED_PRODUCTS_STATUS';
export const SET_RELATED_PRODUCTS_DATA = 'dashboard/SET_RELATED_PRODUCTS_DATA';